if (!process.browser && !__webpack_share_scopes__.default) {
        Object.assign(__webpack_share_scopes__, {
            default: {
                
    "react": {
        [React.version]: {
            loaded: true,
            get: () => Promise.resolve(() => require("react")),
        },
    },
    
    "react-dom": {
        [React.version]: {
            loaded: true,
            get: () => Promise.resolve(() => require("react-dom")),
        },
    },
    
    "@zillow/gdp-client": {
        "1.0.0": {
            loaded: true,
            get: () => Promise.resolve(() => require("@zillow/gdp-client")),
        },
    },
    
    "next": {
        "14.2.25": {
            loaded: true,
            get: () => Promise.resolve(() => require("next")),
        },
    },
    
    "next/head": {
        "14.2.25": {
            loaded: true,
            get: () => Promise.resolve(() => require("next/head")),
        },
    },
    
    "next/dynamic": {
        "14.2.25": {
            loaded: true,
            get: () => Promise.resolve(() => require("next/dynamic")),
        },
    },
    
    "@zillow/dynamic-import-remote": {
        "1.0.0": {
            loaded: true,
            get: () => Promise.resolve(() => require("@zillow/dynamic-import-remote")),
        },
    },
    
    "@zillow/frontier/dynamic": {
        "1.72.1": {
            loaded: true,
            get: () => Promise.resolve(() => require("@zillow/frontier/dynamic")),
        },
    },
    
    "@zillow/web-platform-browser-rum": {
        "1.0.0": {
            loaded: true,
            get: () => Promise.resolve(() => require("@zillow/web-platform-browser-rum")),
        },
    },
    
    "@zillow/shopper-platform-config": {
        "2.0.18": {
            loaded: true,
            get: () => Promise.resolve(() => require("@zillow/shopper-platform-config")),
        },
    },
    
    "styled-components": {
        "5.3.11": {
            loaded: true,
            get: () => Promise.resolve(() => require("styled-components")),
        },
    },
    
    "@zillow/experimentation": {
        "3.4.3": {
            loaded: true,
            get: () => Promise.resolve(() => require("@zillow/experimentation")),
        },
    },
    
    "@zillow/experimentation/server": {
        "3.4.3": {
            loaded: true,
            get: () => Promise.resolve(() => require("@zillow/experimentation/server")),
        },
    },
    
    "@zillow/experimentation/browser": {
        "3.4.3": {
            loaded: true,
            get: () => Promise.resolve(() => require("@zillow/experimentation/browser")),
        },
    },
    
    "styled-components": {
        "5.3.11": {
            loaded: true,
            get: () => Promise.resolve(() => require("styled-components")),
        },
    },
    
    "@zillow/cms-utils": {
        "1.0.0": {
            loaded: true,
            get: () => Promise.resolve(() => require("@zillow/cms-utils")),
        },
    },
    
    "@zillow/constellation": {
        "8.111.2": {
            loaded: true,
            get: () => Promise.resolve(() => require("@zillow/constellation")),
        },
    },
    
            },
        });
    }import '@zillow/constellation-fonts/legacy-zillow-fonts.css';
import '@zillow/constellation-fonts/zillow-fonts.css';
import '../index.css';
import { datadogRum } from '@datadog/browser-rum';
import {
    BlockEnvironmentProvider,
    enrichRumEvent,
    setBlockErrorSink,
} from '@zillow/cms-blocks';
// eslint-disable-next-line
import _unusedCmsUtils, {
    BlockSignalsProvider,
    PagePropsProvider,
} from '@zillow/cms-utils';
import FrontierAppWrapper, {
    initFrontierApp,
    preloadDynamicModules,
} from '@zillow/frontier/host/nextjs/app';
import { cookiesToZGUID, cookiesToZUID } from '@zillow/mortgage-urls';
import { AppWrapper } from '@zillow/page-frame-next-components';
import { ShopperPlatformContextProvider } from '@zillow/shopper-platform-config';
import { page, setdim } from '@zillow/universal-analytics';
import {
    ThemeCmsConstellation,
    ThemeSkunkWorksCmsConstellation,
    getCmsInfoForPage,
    FaqStructuredDataProvider,
    FaqStructuredDataScript,
} from '@zillow/zrs-cms';
import type { Environment } from '@zillow/zrs-cms';
import { merge } from 'lodash';
import App from 'next/app';
import type { AppContext, AppProps } from 'next/app';
import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import 'regenerator-runtime/runtime';
import { ThemeProvider } from 'styled-components';

import { clientProfilerConfig } from '../../server/config';
import { getTheme } from '../../styled-system/themes';
import type { Theme, ThemeName } from '../../styled-system/themes';
import BannerTemplate from '../components/BannerTemplate/BannerTemplate';
import {
    getThemeName,
    parsePathname,
    shouldUseVisualRefreshTheme,
} from '../util/document';
import { trackExposureEvent } from '../util/optimizely';
import { resolveBannerProps } from '../util/resolveBannerProps';

/**
 * The props every page receives from `getInitialProps` below, on top of
 * whatever the page's own data fetching returns. The index signature keeps the
 * object assignable to `PagePropsProvider`'s `Record<string, unknown>` and
 * mirrors the previous `PropTypes.object` contract.
 */
export interface CmsPageProps {
    themeName?: ThemeName;
    theme?: Theme<ThemeName>;
    useVisualRefreshTheme?: boolean;
    [key: string]: unknown;
}

/**
 * Only the two props this component reads. Next.js also passes `router` and the
 * `__N_SSG`/`__N_SSP` flags, but requiring them here would force every caller —
 * including the unit tests — to build a full router. This is the same contract
 * the `propTypes` declaration used to state.
 */
type MyAppProps = Pick<AppProps<CmsPageProps>, 'Component' | 'pageProps'>;

/**
 * `@zillow/page-frame-next-components` ships generated declarations that type
 * `AppWrapper` as `(props: Object) => Object`, which TypeScript rejects as a JSX
 * component (TS2786). Re-typing it is a types-only fix — the value, and so the
 * rendered tree, are unchanged. `Object` does not overlap with `FC`, so the
 * assertion has to go via `unknown`.
 */
const PageFrameAppWrapper = AppWrapper as unknown as React.FC<{
    children?: React.ReactNode;
    clientProfilerConfig?: unknown;
}>;

// preloadDynamicModules ensures dynamic MFEs are loaded before React hydration.
// Uses IIFE instead of top-level await for Jest compatibility.
(async () => {
    await preloadDynamicModules();
})();

function isMobile() {
    // These are the user agents that we want to consider mobile.
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
    ];

    return (
        typeof window !== 'undefined' &&
        toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem))
    );
}

if (typeof window !== 'undefined') {
    datadogRum.init({
        applicationId: '670a99d8-3d41-4858-ae1f-cb66797af887',
        clientToken: 'pubb1845c6bcbfd371c2a207a83befcffc0',
        site: 'datadoghq.com',
        service: 'cms-constellation',
        env: process.env.NEXT_PUBLIC_ENV,
        version: process.env.NEXT_PUBLIC_SERVICE_VERSION,
        sessionSampleRate: parseInt(
            process.env.NEXT_PUBLIC_DATADOG_RUM_SAMPLE_RATE || '0'
        ),
        startSessionReplayRecordingManually: true,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'allow',
        // Enhanced error filtering to reduce noise
        beforeSend: (event, context) => {
            // Only filter error events
            if (event?.type === 'error') {
                // Errors routed through setBlockErrorSink already carry exact
                // attribution, so they are never noise. They must bypass the
                // filters below: a remote whose chunk fails to load surfaces as
                // "ChunkLoadError: Loading chunk ... failed", which the
                // third-party script filter would otherwise drop — the exact
                // failure class this reporting exists to capture.
                if (event.context?._cms_block) {
                    return true;
                }

                const error = event.error;

                // Filter out browser extension errors
                if (
                    error.stack &&
                    (error.stack.includes('extension://') ||
                        error.stack.includes('moz-extension://') ||
                        error.stack.includes('safari-extension://') ||
                        error.stack.includes('chrome-extension://'))
                ) {
                    return false;
                }

                // Filter out ResizeObserver errors (common browser noise)
                if (
                    error.message &&
                    error.message.includes('ResizeObserver loop limit exceeded')
                ) {
                    return false;
                }

                // Filter out network errors that are expected
                if (
                    error.type === 'NETWORK_ERROR' ||
                    error.name === 'AbortError'
                ) {
                    return false;
                }

                // Filter out script loading errors from third parties
                if (
                    error.message &&
                    (error.message.includes('Script error') ||
                        error.message.includes(
                            'Non-Error promise rejection captured'
                        ) ||
                        error.message.includes('Loading chunk') ||
                        error.message.includes('ChunkLoadError'))
                ) {
                    return false;
                }

                // Filter out ad blocker and third-party script errors
                if (
                    error.stack &&
                    (error.stack.includes('googletag') ||
                        error.stack.includes('google-analytics') ||
                        error.stack.includes('facebook.net') ||
                        error.stack.includes('doubleclick.net') ||
                        error.stack.includes('googleadservices.com'))
                ) {
                    return false;
                }

                // Attribute surviving errors to the MFE block that produced them
                enrichRumEvent(event, context);
            }

            return true;
        },
    });

    // Client sink for block errors reported from cms-blocks (GWEB-20). The
    // attribution is passed as context so monitors can filter on @context.module.
    setBlockErrorSink((error, attribution) => {
        datadogRum.addError(error, attribution);
    });
}

const MyApp = ({ Component, pageProps }: MyAppProps) => {
    // Read zguid cookie synchronously to avoid double-fetch in MFE Split SDK.
    // Pages are statically rendered (SSG/ISR) so cookies are not available at build time;
    // the typeof guard returns empty string during SSG.
    const zguid =
        typeof document !== 'undefined'
            ? cookiesToZGUID(document.cookie) || ''
            : '';

    // Seed encodedZuid so hosted MFEs can evaluate
    // user-keyed Split flags via useViewerState() without a double-render.
    const encodedZuid =
        typeof document !== 'undefined'
            ? cookiesToZUID(document.cookie) || ''
            : '';

    useEffect(() => {
        // For how-much-is-my-home-worth analytics
        const params = new URLSearchParams(window.location.search);
        if (params.has('zpid')) {
            setdim({ dimension2: params.get('zpid') });
        }

        // Function to track page view events
        const trackPageView = () => {
            // https://gitlab.zgtools.net/zillow/npm/universal-analytics/-/blob/master/README-NEWLANE.md#pagepath-properties-options
            // https://dataportal.zillowgroup.net/event-registry/2284
            page(
                window.location.pathname,
                {},
                {
                    newLaneEvent: {
                        envelope: {
                            event_type_id: '2284',
                            event_type_version_id: '1',
                            event_template_id: '126',
                            event_template_version_id: '1',
                        },
                        clickstream_trigger: {
                            trigger_type_nm: 'view',
                            trigger_location_nm: 'cms',
                            trigger_source_nm: 'cms',
                            trigger_object_nm: 'no_trigger_object',
                        },
                        semantic: {
                            semantic_event_nm: 'view_content',
                        },
                        cms_info: getCmsInfoForPage(pageProps),
                    },
                }
            );
        };

        // Track page view immediately on mount
        // IMPORTANT: We call this directly instead of waiting for DOMContentLoaded
        // because in a Next.js SSR app, DOMContentLoaded fires before React hydration
        // completes. By the time useEffect runs, the event has already fired and
        // adding a listener would never execute.
        trackPageView();

        // Also track page view when navigating back from bfcache. The above will not
        // double track the page view, as on bfcache the page is not re-rendered.
        const handlePageShow = (event: PageTransitionEvent) => {
            // event.persisted is true when the page is loaded from bfcache
            if (event.persisted) {
                trackPageView();
            }
        };

        window.addEventListener('pageshow', handlePageShow);

        return () => {
            window.removeEventListener('pageshow', handlePageShow);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Disable Chrome's behavior where if the current user has already visited
    // the page and has scrolled to a given point, Chrome will restore that
    // scroll position and ignore the deep link.
    useEffect(() => {
        if ('scrollRestoration' in window.history && window.location.hash) {
            window.history.scrollRestoration = 'manual';
        }
    }, []);

    // Track Optimizely exposure events with Clickstream.
    useEffect(() => {
        trackExposureEvent();
    }, []);

    // Initialize Split client so MFEs can resolve treatments; state update
    // re-renders the tree so treatment hooks re-evaluate once the client is ready.
    const [, setSplitReady] = useState(false);

    useEffect(() => {
        if (!zguid) return;
        import('../util/splitTest')
            .then(({ initSplitClient: init }) =>
                init({
                    isProd: process.env.NEXT_PUBLIC_ENV === 'prod',
                    clientKey: zguid,
                })
            )
            .then(({ trusted }) => setSplitReady(trusted))
            .catch(Function.prototype as () => void);
    }, [zguid]);

    return (
        <>
            <FrontierAppWrapper>
                <ShopperPlatformContextProvider
                    initialState={{
                        gdpExternalUrl:
                            process.env.NEXT_PUBLIC_ENV === 'prod'
                                ? '/graphql/'
                                : 'https://www.qa.zillow.net/graphql/',
                        viewer: { guid: zguid, encodedZuid },
                    }}
                >
                    <PageFrameAppWrapper
                        clientProfilerConfig={merge(clientProfilerConfig, {
                            staticDimensions: {
                                platform: isMobile() ? 'mobile' : 'desktop',
                            },
                        })}
                    >
                        <BlockSignalsProvider>
                            <FaqStructuredDataProvider>
                                {/*
                                 * v8 compatibility shim. Nothing in `src/` reads this
                                 * theme any more; it is kept for code rendered through
                                 * the page tree that still does:
                                 * - zrs-cms v8 components (Carousel, PaymentDonutChart
                                 *   and the calculators built on it, HubspotEmbed,
                                 *   RefinanceCalculator), whose v8 `token()` /
                                 *   `spaceMixin` read `props.theme`
                                 * - cms-blocks v8 blocks (Table, Image, BlockList)
                                 * - Frontier MFE remotes, which share this host's
                                 *   `styled-components` instance (next.config.js
                                 *   `sharedDependencies`) and so read this context
                                 * Remove it only once those have migrated to v10.
                                 */}
                                <ThemeProvider
                                    theme={
                                        pageProps.useVisualRefreshTheme
                                            ? ThemeSkunkWorksCmsConstellation
                                            : ThemeCmsConstellation
                                    }
                                >
                                    <PagePropsProvider pageProps={pageProps}>
                                        <BlockEnvironmentProvider
                                            // NEXT_PUBLIC_ENV is `string | undefined` to
                                            // TypeScript; the provider wants the narrower
                                            // `Environment` union. Asserting keeps the
                                            // previous runtime behaviour (an unset var is
                                            // still forwarded as-is) rather than
                                            // introducing a default here.
                                            environment={
                                                process.env
                                                    .NEXT_PUBLIC_ENV as Environment
                                            }
                                        >
                                            {/* Ahead of the page component so
                                                the banner precedes every
                                                layout's header and nav in
                                                document order, but inside the
                                                block providers so the blocks
                                                nested in it get the same
                                                context as page blocks. */}
                                            <BannerTemplate
                                                {...resolveBannerProps(
                                                    pageProps
                                                )}
                                            />
                                            <Component {...pageProps} />
                                        </BlockEnvironmentProvider>
                                    </PagePropsProvider>
                                </ThemeProvider>

                                <FaqStructuredDataScript />
                            </FaqStructuredDataProvider>
                        </BlockSignalsProvider>
                    </PageFrameAppWrapper>
                </ShopperPlatformContextProvider>
            </FrontierAppWrapper>
            <Head>
                {pageProps.themeName === 'legacy-zillow' && (
                    <>
                        <link
                            rel="preload"
                            href="https://www.zillowstatic.com/s3/constellation-website/public/shared/fonts/open-sans/LATEST/open-sans-variable.woff2"
                            as="font"
                            type="font/woff2"
                            crossOrigin="anonymous"
                        />
                    </>
                )}
                {/*
                 * `zpro` headings use the Object Sans Bold face from its own
                 * font family (see @zillow/cms-panda-themes src/zpro/values.ts),
                 * so it preloads that instead of Zillow's Heavy face.
                 */}
                {(pageProps.themeName === 'zillow' ||
                    pageProps.themeName === 'zpro') && (
                    <>
                        <link
                            rel="preload"
                            href={
                                pageProps.themeName === 'zpro'
                                    ? 'https://www.zillowstatic.com/s3/constellation-website/public/shared/fonts/object-sans/LATEST/object-sans-bold.woff2'
                                    : 'https://www.zillowstatic.com/s3/constellation-website/public/shared/fonts/object-sans/LATEST/object-sans-heavy.woff2'
                            }
                            as="font"
                            type="font/woff2"
                            crossOrigin="anonymous"
                        />
                        <link
                            rel="preload"
                            href="https://www.zillowstatic.com/s3/constellation-website/public/shared/fonts/inter/LATEST/inter-variable.woff2"
                            as="font"
                            type="font/woff2"
                            crossOrigin="anonymous"
                        />
                    </>
                )}
                {pageProps.theme && (
                    <style
                        type="text/css"
                        id={pageProps.theme.id}
                        dangerouslySetInnerHTML={{
                            __html: pageProps.theme.css,
                        }}
                    />
                )}
            </Head>
        </>
    );
};

MyApp.getInitialProps = async (appContext: AppContext) => {
    const appProps = await App.getInitialProps(appContext);
    // Refresh remote module versions for ISR/SSG
    await initFrontierApp();

    // Compute theme data for head tags
    const { asPath = '/', query = {} } = appContext.ctx;
    const pathname = parsePathname(asPath);
    const useVisualRefreshTheme = shouldUseVisualRefreshTheme(pathname, query);
    const themeName: ThemeName = getThemeName(pathname, useVisualRefreshTheme);
    const theme = await getTheme(themeName);

    return {
        ...appProps,
        pageProps: {
            ...appProps.pageProps,
            themeName,
            theme,
            useVisualRefreshTheme,
        },
    };
};

export default MyApp;
